export default "__VITE_ASSET__zNR3IPvw__"